import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ChevronRight, Home, TrendingUp, TrendingDown, Search, Calendar, MapPin } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
const markets = ['All Markets', 'Kampala (Owino)', 'Jinja', 'Mbale', 'Gulu', 'Mbarara', 'Lira', 'Arua'];
const priceData = [{
  commodity: 'Maize (Grain)',
  unit: 'per kg',
  kampala: 1200,
  jinja: 1100,
  mbale: 1050,
  gulu: 1300,
  mbarara: 1150,
  change: '+8.2%',
  trend: 'up'
}, {
  commodity: 'Beans (Mixed)',
  unit: 'per kg',
  kampala: 3500,
  jinja: 3200,
  mbale: 3000,
  gulu: 3800,
  mbarara: 3300,
  change: '+5.1%',
  trend: 'up'
}, {
  commodity: 'Rice (Local)',
  unit: 'per kg',
  kampala: 4500,
  jinja: 4200,
  mbale: 3800,
  gulu: 4800,
  mbarara: 4400,
  change: '+3.4%',
  trend: 'up'
}, {
  commodity: 'Cassava (Fresh)',
  unit: 'per kg',
  kampala: 800,
  jinja: 700,
  mbale: 650,
  gulu: 900,
  mbarara: 750,
  change: '-2.1%',
  trend: 'down'
}, {
  commodity: 'Sweet Potatoes',
  unit: 'per kg',
  kampala: 1000,
  jinja: 900,
  mbale: 850,
  gulu: 1100,
  mbarara: 950,
  change: '+1.5%',
  trend: 'up'
}, {
  commodity: 'Groundnuts (Shelled)',
  unit: 'per kg',
  kampala: 7000,
  jinja: 6500,
  mbale: 6200,
  gulu: 7500,
  mbarara: 6800,
  change: '+12.3%',
  trend: 'up'
}, {
  commodity: 'Sorghum',
  unit: 'per kg',
  kampala: 1800,
  jinja: 1600,
  mbale: 1500,
  gulu: 1400,
  mbarara: 1700,
  change: '-3.5%',
  trend: 'down'
}, {
  commodity: 'Cooking Bananas (Matooke)',
  unit: 'per bunch',
  kampala: 15000,
  jinja: 12000,
  mbale: 10000,
  gulu: 18000,
  mbarara: 11000,
  change: '+6.8%',
  trend: 'up'
}, {
  commodity: 'Fresh Milk',
  unit: 'per litre',
  kampala: 1800,
  jinja: 1500,
  mbale: 1400,
  gulu: 2000,
  mbarara: 1200,
  change: '+4.2%',
  trend: 'up'
}, {
  commodity: 'Eggs',
  unit: 'per tray (30)',
  kampala: 12000,
  jinja: 11500,
  mbale: 11000,
  gulu: 13000,
  mbarara: 11500,
  change: '+2.8%',
  trend: 'up'
}];
const livestockPrices = [{
  animal: 'Local Bull (mature)',
  price: '1,500,000 - 2,500,000',
  change: '+10.5%',
  trend: 'up'
}, {
  animal: 'Exotic Dairy Cow',
  price: '3,000,000 - 5,000,000',
  change: '+8.2%',
  trend: 'up'
}, {
  animal: 'Goat (mature)',
  price: '150,000 - 300,000',
  change: '+6.1%',
  trend: 'up'
}, {
  animal: 'Pig (mature)',
  price: '250,000 - 450,000',
  change: '+4.3%',
  trend: 'up'
}, {
  animal: 'Local Chicken',
  price: '15,000 - 25,000',
  change: '+3.7%',
  trend: 'up'
}, {
  animal: 'Tilapia (per kg)',
  price: '12,000 - 18,000',
  change: '-1.2%',
  trend: 'down'
}];
export function MarketPricesPage() {
  const [searchQuery, setSearchQuery] = useState('');
  const filtered = priceData.filter(item => item.commodity.toLowerCase().includes(searchQuery.toLowerCase()));
  return <>
      <Header data-id="element-1015" />
      <main className="flex-grow pt-[160px] md:pt-[148px] bg-gray-50 pb-20" data-id="element-1016">
        <div className="relative text-white py-32 md:py-48 overflow-hidden" data-id="element-1017">
          <div className="absolute inset-0 bg-cover bg-center" style={{
          backgroundImage: 'url("https://images.unsplash.com/photo-1488459716781-31db52582fe9?w=1600&h=600&fit=crop")'
        }} data-id="element-1018"></div>
          <div className="absolute inset-0 bg-uganda-green/80" data-id="element-1019"></div>
          <div className="relative max-w-7xl mx-auto px-4 md:px-8" data-id="element-1020">
            <div className="flex items-center text-sm text-green-100 mb-6" data-id="element-1021">
              <Link to="/" className="hover:text-white flex items-center" data-id="element-1022">
                <Home className="w-4 h-4 mr-1" data-id="element-1023" /> Home
              </Link>
              <ChevronRight className="w-4 h-4 mx-2" data-id="element-1024" />
              <span data-id="element-1025">Data & Statistics</span>
              <ChevronRight className="w-4 h-4 mx-2" data-id="element-1026" />
              <span className="text-white font-medium" data-id="element-1027">Market Prices</span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-1028">
              Market Prices
            </h1>
            <p className="text-lg text-green-50 max-w-3xl leading-relaxed mb-8" data-id="element-1029">
              Current wholesale and retail prices for agricultural commodities
              across major markets in Uganda. Updated monthly.
            </p>
            <div className="max-w-2xl relative" data-id="element-1030">
              <input type="text" placeholder="Search commodity..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-12 pr-4 py-4 rounded-lg text-uganda-black focus:outline-none focus:ring-2 focus:ring-uganda-yellow shadow-lg" data-id="element-1031" />
              <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 w-6 h-6" data-id="element-1032" />
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 md:px-8 mt-12" data-id="element-1033">
          <div className="flex items-center gap-3 text-sm text-gray-500 mb-6" data-id="element-1034">
            <Calendar className="w-4 h-4" data-id="element-1035" />
            <span data-id="element-1036">Last updated: April 2024</span>
            <span className="w-1 h-1 bg-gray-300 rounded-full" data-id="element-1037" />
            <span data-id="element-1038">Prices in Uganda Shillings (UGX)</span>
          </div>

          {/* Crop Prices Table */}
          <h2 className="text-2xl font-bold text-uganda-black mb-4" data-id="element-1039">
            Crop & Food Commodity Prices
          </h2>
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden mb-12" data-id="element-1040">
            <div className="overflow-x-auto" data-id="element-1041">
              <table className="w-full" data-id="element-1042">
                <thead data-id="element-1043">
                  <tr className="bg-gray-50 border-b border-gray-200" data-id="element-1044">
                    <th className="text-left px-4 py-3 text-xs font-bold text-gray-600 uppercase tracking-wider" data-id="element-1045">
                      Commodity
                    </th>
                    <th className="text-right px-4 py-3 text-xs font-bold text-gray-600 uppercase tracking-wider" data-id="element-1046">
                      Kampala
                    </th>
                    <th className="text-right px-4 py-3 text-xs font-bold text-gray-600 uppercase tracking-wider hidden md:table-cell" data-id="element-1047">
                      Jinja
                    </th>
                    <th className="text-right px-4 py-3 text-xs font-bold text-gray-600 uppercase tracking-wider hidden lg:table-cell" data-id="element-1048">
                      Mbale
                    </th>
                    <th className="text-right px-4 py-3 text-xs font-bold text-gray-600 uppercase tracking-wider hidden lg:table-cell" data-id="element-1049">
                      Gulu
                    </th>
                    <th className="text-right px-4 py-3 text-xs font-bold text-gray-600 uppercase tracking-wider hidden md:table-cell" data-id="element-1050">
                      Mbarara
                    </th>
                    <th className="text-right px-4 py-3 text-xs font-bold text-gray-600 uppercase tracking-wider" data-id="element-1051">
                      Monthly
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-1052">
                  {filtered.map((item, i) => <tr key={item.commodity} className={`border-b border-gray-100 ${i % 2 === 0 ? '' : 'bg-gray-50/50'}`} data-id="element-1053">
                      <td className="px-4 py-3" data-id="element-1054">
                        <div className="font-semibold text-uganda-black text-sm" data-id="element-1055">
                          {item.commodity}
                        </div>
                        <div className="text-xs text-gray-400" data-id="element-1056">{item.unit}</div>
                      </td>
                      <td className="px-4 py-3 text-right text-sm text-gray-700 font-medium" data-id="element-1057">
                        {item.kampala.toLocaleString()}
                      </td>
                      <td className="px-4 py-3 text-right text-sm text-gray-700 hidden md:table-cell" data-id="element-1058">
                        {item.jinja.toLocaleString()}
                      </td>
                      <td className="px-4 py-3 text-right text-sm text-gray-700 hidden lg:table-cell" data-id="element-1059">
                        {item.mbale.toLocaleString()}
                      </td>
                      <td className="px-4 py-3 text-right text-sm text-gray-700 hidden lg:table-cell" data-id="element-1060">
                        {item.gulu.toLocaleString()}
                      </td>
                      <td className="px-4 py-3 text-right text-sm text-gray-700 hidden md:table-cell" data-id="element-1061">
                        {item.mbarara.toLocaleString()}
                      </td>
                      <td className="px-4 py-3 text-right" data-id="element-1062">
                        <span className={`inline-flex items-center gap-1 text-xs font-bold ${item.trend === 'up' ? 'text-green-600' : 'text-red-500'}`} data-id="element-1063">
                          {item.trend === 'up' ? <TrendingUp className="w-3 h-3" data-id="element-1064" /> : <TrendingDown className="w-3 h-3" data-id="element-1065" />}
                          {item.change}
                        </span>
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
            <div className="px-4 py-3 bg-gray-50 text-xs text-gray-500 border-t border-gray-200" data-id="element-1066">
              Source: MAAIF Market Information System. Prices are indicative
              wholesale prices.
            </div>
          </div>

          {/* Livestock Prices */}
          <h2 className="text-2xl font-bold text-uganda-black mb-4" data-id="element-1067">
            Livestock & Fish Prices
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-1068">
            {livestockPrices.map((item, index) => <motion.div key={item.animal} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.06
          }} className="bg-white rounded-xl p-5 shadow-sm border border-gray-200" data-id="element-1069">
                <p className="text-sm text-gray-500 mb-1" data-id="element-1070">{item.animal}</p>
                <p className="text-xl font-bold text-uganda-black mb-2" data-id="element-1071">
                  UGX {item.price}
                </p>
                <span className={`inline-flex items-center gap-1 text-sm font-semibold ${item.trend === 'up' ? 'text-green-600' : 'text-red-500'}`} data-id="element-1072">
                  {item.trend === 'up' ? <TrendingUp className="w-4 h-4" data-id="element-1073" /> : <TrendingDown className="w-4 h-4" data-id="element-1074" />}
                  {item.change} vs last month
                </span>
              </motion.div>)}
          </div>
        </div>
      </main>
      <Footer data-id="element-1075" />
    </>;
}